import React, { useEffect, useRef } from 'react';

const BigBurst = (props) => {
    
    //starFour : &#10022;
    //starFive : &#9733;
    //klover: &#10018; 

  return (
    <>
        <div className='star-container'>
            <span className='star star-1'>&#10022;</span>
            <span className='star star-2'>&#10022;</span>
            <span className='star star-3'>&#10022;</span>
            <span className='star star-4'>&#10022;</span>
            <span className='star star-5'>&#10018;</span>
            <span className='star star-6'>&#10018;</span>
            <span className='star star-7'>&#10018;</span>
            <span className='star star-8'>&#10018;</span>
            <span className='star star-9'>&#10022;</span>
        </div>
        
    </>
  )
}

export default BigBurst;